import "./HomeInspectionService.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServices from "./sections/OurServices";
import HowItWorks from "./sections/HowItWorks";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomeInspectionServicePage() {
  return <div>
      <Header />
      <Hero />
      <OurServices />
      <HowItWorks />
      <Contact />
      <Footer />
    </div>;
}